export default "__VITE_ASSET__CuvVpCqz__"